import { useAuth } from "../../../../contexts/AuthContext";
import { AUTH_SHIBUYA } from "../../../../utils/config";
import { getImageUrlStr } from "../../../../utils/courseData";
import DetailTable from "../../../../components/ui/AdminDetailTable";

const Detail = ({ courseData }) => {
  // ユーザー情報
  const { user } = useAuth();
  // 講座詳細情報
  const course = courseData;

  const getLinkJSXElement = (url) => {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {url}
      </a>
    );
  };

  const getTableElements = () => {
    if (user.authority == AUTH_SHIBUYA) {
      //権限 渋谷区
      return [
        { label: "講座ID", value: course.id },
        { label: "講座名", value: course.course_name },
        { label: "講座内容", value: course.content },
        { label: "実施機関", value: course.organ },
        { label: "大学ID", value: course.univ_id },
        { label: "申込期間(FROM)", value: course.period_f },
        { label: "申込期間(TO)", value: course.period_t },
        { label: "定員", value: course.capacity },
        { label: "最小催行人数", value: course.minimum },
        { label: "申込者数", value: course.application },
        { label: "講座開催日・講座時間", value: course.period },
        { label: "全回数", value: course.all_times },
        { label: "受講料", value: course.tuition_fee },
        {
          label: "会場",
          value: course.venue_detail
            ? course.venue + "\r\n" + course.venue_detail
            : course.venue,
        },
        { label: "住所", value: course.street_address },
        { label: "キャンセル可否", value: course.cancel },
        { label: "単位/1回出席あたり", value: course.unit },
        { label: "受講料/1回あたり", value: course.tuition_fee1 },
        { label: "材料費", value: course.material_cost },
        { label: "講座カテゴリ", value: course.category },
        {
          label: "画像URL",
          value: getLinkJSXElement(getImageUrlStr(course.image)),
        },
        { label: "公開・非公開", value: course.status },
        { label: "講座出席者延べ人数", value: course.attendee },
        { label: "検索キーワード", value: course.keyword },
        { label: "記事URL", value: getLinkJSXElement(course.permalink) },
      ];
    } else {
      return [
        { label: "講座名", value: course.course_name },
        { label: "講座内容", value: course.content },
        { label: "実施機関", value: course.organ },
        { label: "申込期間(FROM)", value: course.period_f },
        { label: "申込期間(TO)", value: course.period_t },
        { label: "定員", value: course.capacity },
        { label: "講座開催日・講座時間", value: course.period },
        { label: "全回数", value: course.all_times },
        { label: "受講料", value: course.tuition_fee },
        {
          label: "会場",
          value: course.venue_detail
            ? course.venue + "\r\n" + course.venue_detail
            : course.venue,
        },
        { label: "キャンセル可否", value: course.cancel },
        { label: "単位/1回出席あたり", value: course.unit },
        { label: "材料費", value: course.material_cost },
      ];
    }
  };

  return <DetailTable elements={getTableElements()}></DetailTable>;
};

export default Detail;
